import {Component, HostBinding, OnInit} from '@angular/core';
import {OptionsService} from './utils/services/options.service';
import { NavigationEnd, NavigationCancel, NavigationError, NavigationStart, Router } from '@angular/router';
const H = window['H'];

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {

  public notificationOptions = {
    position: ['bottom', 'right'],
    timeOut: 1500,
    lastOnBottom: true
  };
  @HostBinding('class') public bodyClasses;//sidebar-collapse
  constructor(private optionsService: OptionsService, private router: Router) {
    const platform = new H.service.Platform({
      app_id: 'DvkMLJUCGTNvYUfJKvjI',
      app_code: 'WCu2vYFedd98VySNf6gWWQ',
      useCIT: false,
      useHTTPS: true
    });
    platform.createDefaultLayers();
  }
  isRouting = false;
  ngOnInit() {
    this.optionsService.options$.subscribe((options) => {
      this.bodyClasses = options ? options.bodyClasses : '';
    });

    this.router.events.forEach(event => {
      // this.logger.log("NavigationEvent", event);
      if (event instanceof NavigationStart) {
        this.isRouting = true;
      }

      if (event instanceof NavigationEnd) {
        // this.logger.log("NavigationEnd");
        this.isRouting = false;
      }
      if (event instanceof NavigationCancel) {
        this.isRouting = false;
      }
      if (event instanceof NavigationError) {
        this.isRouting = false;
      }
    });

  }

}



// WEBPACK FOOTER //
// C:/Biziclick/bizisystem/src/app/app.component.ts